var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-5 pa-5",attrs:{"min-height":"300px"}},[_c('CardTitle'),_c('Table'),(_vm.getShowDialogRegisterExchangeControl)?_c('AddDialog'):_vm._e(),_c('LayerLoad'),_c('loadScreen')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }